import { store } from "../store/store";
import Session from "../layouts/Session";

const SessionLogin = () => import("../views/session/Login.vue");
const AccountTypeSelectionPage = () =>
  import("../views/session/AccountTypeSelectionPage.vue");
const EmployeePage = () => import("../views/session/EmployeePage.vue");
const SessionSignUp = () => import("../views/session/SignUp.vue");
const SessionForgotPassword = () =>
  import("../views/session/ForgotPassword.vue");
const SessionResetPassword = () => import("../views/session/ResetPassword.vue");
const MaintenanceMode = () => import("../views/session/MaintenanceMode.vue");

const ifNotAuthenticated = async (to, from, next) => {
  const isDemoMode = await store.getters["auth/isDemoMode"];
  if (isDemoMode) {
    next({ name: "session-login" });
    return;
  }

  if (
    to.query.access !== "approved" &&
    !(to.query.audit === "true" && to.query.custom_invitation === "true") &&
    to.name === "session-sign-up"
  ) {
    window.location.href = "https://center.ai/pl/cennik/";
  }

  const isAuthenticated = await store.getters["auth/isAuthenticated"];
  if (!isAuthenticated) {
    next();
    return;
  }

  next({ name: "visibility-business-addresses" });
};

export default {
  path: "/",
  component: Session,
  children: [
    {
      path: "/session/sign-up",
      name: "session-sign-up",
      component: SessionSignUp,
      beforeEnter: ifNotAuthenticated,
      meta: {
        analyticsEventId: "/session/sign-up",
        title: "message.common.signUp",
        metaTitle: "message.meta.signUp.title",
        metaTags: [
          {
            name: "description",
            content: "message.meta.signUp.description"
          }
        ],
        breadcrumb: null,
        requiresAuth: false
      }
    },
    {
      path: "/session/login",
      name: "session-login",
      component: SessionLogin,
      meta: {
        analyticsEventId: "/session/login",
        title: "message.common.login",
        metaTitle: "message.meta.login.title",
        metaTags: [
          {
            name: "description",
            content: "message.meta.login.description"
          }
        ],
        breadcrumb: null,
        requiresAuth: false
      }
    },
    {
      path: "/session/select-account-type",
      name: "session-select-account-type",
      component: AccountTypeSelectionPage,
      meta: {
        analyticsEventId: "/session/select-account-type",
        title: "message.common.login",
        metaTitle: "message.meta.login.title",
        metaTags: [
          {
            name: "description",
            content: "message.meta.login.description"
          }
        ],
        breadcrumb: null,
        requiresAuth: false
      }
    },
    {
      path: "/session/employee-page",
      name: "session-employee-page",
      component: EmployeePage,
      meta: {
        analyticsEventId: "/session/employee-page",
        title: "message.common.login",
        metaTitle: "message.meta.login.title",
        metaTags: [
          {
            name: "description",
            content: "message.meta.login.description"
          }
        ],
        breadcrumb: null,
        requiresAuth: false
      }
    },
    {
      path: "/session/forgot-password",
      name: "session-forgot-password",
      component: SessionForgotPassword,
      beforeEnter: ifNotAuthenticated,
      meta: {
        analyticsEventId: "/session/forgot-password",
        title: "message.common.forgotPassword",
        breadcrumb: null,
        requiresAuth: false
      }
    },
    {
      path: "/password-reset/:uid/:token",
      name: "session-reset-password",
      component: SessionResetPassword,
      beforeEnter: ifNotAuthenticated,
      meta: {
        analyticsEventId: "/password-reset/:uid/:token",
        title: "message.common.resetPassword",
        breadcrumb: null,
        requiresAuth: false
      }
    },
    {
      path: "/service-unavailable",
      name: "maintenance-mode",
      component: MaintenanceMode,
      meta: {
        analyticsEventId: "/service-unavailable"
      }
    }
  ]
};
